var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('div',{staticClass:"flex mt-8 w-full",staticStyle:{"min-height":"150px"}},[_c('HistoricoVendas',{staticClass:"w-full",attrs:{"usuariosIds":[1,176,246]}})],1),_c('div',{staticClass:"flex my-8 w-full",staticStyle:{"min-height":"200px"}},[_c('AwaitingContratc',{staticClass:"mb-8 w-full"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }